var exports = {
  "kL": "xdbfd91f1--984276--container",
  "vJ": "xdbfd91f1--984276--builder_info",
  "oR": "xdbfd91f1--984276--builder_badge",
  "eX": "xdbfd91f1--984276--builder_name",
  "sJ": "xdbfd91f1--984276--grey_text",
  "Sx": "xdbfd91f1--984276--builder_image",
  "oK": "xdbfd91f1--984276--default_builder",
  "OF": "xdbfd91f1--984276--default_builder_img",
  "IB": "xdbfd91f1--984276--villages_count_container",
  "Qp": "xdbfd91f1--984276--work_time",
  "M6": "xdbfd91f1--984276--builder_popup_link",
  "BV": "xdbfd91f1--984276--fadeLink",
};

module.exports = exports;
